export default {
    "fr": {
        "dxFileUploader-selectFile": "Choisissez des fichiers",
        "dxFileUploader-dropFile": "Ou déposez les ici.",
        "dxFileUploader-upload": "Envoyer",
        "dxFileUploader-uploaded": "Envoyé",
        "dxFileUploader-kb": "ko",
        "dxFileUploader-Mb": "Mo",
        "dxFileUploader-Gb": "Go",
    }
}